module.exports = __webpack_public_path__ + "static/media/oppimg.83b9ed01.svg";